import { atom } from "jotai";
import { userIdAtom } from "./auth.state";
import { syncAttemptCompletedAtom } from "./sync.state";

export type AppMode = "authed" | "demo";

export const appModeAtom = atom<AppMode>("authed");

export const queriesEnabledAtom = atom<boolean>((get) => {
  const mode = get(appModeAtom);
  const userId = get(userIdAtom);
  const syncAttemptCompleted = get(syncAttemptCompletedAtom);
  return mode === "demo" ? true : !!userId && syncAttemptCompleted;
});
